// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"_o3XUFomibKgEwurtlnh"};